import { __rest } from "tslib";
import { createElement, forwardRef } from 'rax';
import classNames from 'classnames';
import View from '../../view';
import Icon from '../../icon';
import ListItemCaption from './caption';
import ItemContent from './content';
import { ListItemAction, ListItemMedia } from './media';
import ItemTitle from './title';
import { isFunction, isString } from '../../utils';
const arrowIconMap = {
    right: 'arrow-right',
    up: 'arrow-up',
    down: 'arrow-down',
    loading: 'loading',
};
const renderExtra = (ext) => {
    if (isString(ext)) {
        return <ListItemCaption>{ext}</ListItemCaption>;
    }
    else if (ext) {
        return ext;
    }
    return null;
};
const ListItem = (props, ref) => {
    const { children, prefix = 'mt-', arrow, media, title, subTitle, description, extra, className, onClick, disabled = false } = props, others = __rest(props, ["children", "prefix", "arrow", "media", "title", "subTitle", "description", "extra", "className", "onClick", "disabled"]);
    return (<View {...others} className={classNames(`${prefix}list-item`, {
            [`${prefix}list-item--clickable`]: isFunction(onClick),
            [`${prefix}list-item--disabled`]: disabled,
        }, className)} ref={ref} onClick={(...args) => {
            if (!disabled && onClick) {
                onClick(...args);
            }
        }}>
      {media ? <ListItemMedia>{media}</ListItemMedia> : null}
      <View className={`${prefix}list-item-container`}>
        {title || description ? (<ItemContent>
            {title ? <ItemTitle>{title}</ItemTitle> : null}
            {subTitle ? <ListItemCaption>{subTitle}</ListItemCaption> : null}
            {description ? <ListItemCaption>{description}</ListItemCaption> : null}
          </ItemContent>) : null}
        {extra || isString(arrow) ? (<ListItemAction>
            {renderExtra(extra)}
            {isString(arrow) ? (<Icon size="xs" className={`${prefix}list-item-icon`} name={arrowIconMap[arrow]}/>) : null}
          </ListItemAction>) : null}
        {children}
      </View>
    </View>);
};
ListItem.displayName = 'ListItem';
export default forwardRef(ListItem);
